import * as Sentry from '@sentry/react';
import { Component, ReactNode } from 'react';

export const FallbackUI = ({ eventId = '' }: { eventId?: string }) => (
  <div style={{ maxWidth: '1280px', margin: '0 auto', padding: '20px' }}>
    <h3>We apologize, but an error occurred.</h3>
    <p>
      You can report your issue using the button below and then close your browser tab and login
      again. If the issue continues email us at{' '}
      <a href="mailto:support@senditgigs.com">support@senditgigs.com</a>
    </p>
    <button type="button" className="mt-2" onClick={() => Sentry.showReportDialog({ eventId })}>
      Report feedback
    </button>
  </div>
);

export class ExampleBoundary extends Component<
  {
    children: ReactNode;
  },
  {
    eventId?: string;
    hasError: boolean;
  }
> {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.withScope((scope) => {
      scope.setExtras(errorInfo);
      const eventId = Sentry.captureException(error);
      this.setState({ eventId });
    });
  }

  render() {
    const { eventId, hasError } = this.state;
    const { children } = this.props;

    // render fallback UI
    if (hasError) {
      return <FallbackUI eventId={eventId} />;
    }

    // when there's not an error, render children untouched
    return children;
  }
}

export default ExampleBoundary;
